import React, { CSSProperties } from 'react';

import clsx from 'clsx';

import AppConfig from './../AppConfig';

import { Partner } from '../model/domain/Partner';

export interface PartnerLogoProps {
  partner: Partner;
  style?: CSSProperties;
}

const PartnerLogo: React.FC<PartnerLogoProps> = ({ partner, style }) => {
  return (
    <div className={clsx(style)}>
      <a
        tabIndex={-1}
        target="blank"
        href={partner.url}
        className="flex h-full w-full items-center justify-center"
      >
        <img
          className="max-h-[23px] max-w-[200px] pr-[54px]"
          src={AppConfig.apiUrl + '/app/media/' + partner.logoId}
          alt="Logo of the partner"
        />
      </a>
    </div>
  );
};

export default PartnerLogo;
